// common사용자 데이터

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, apiClient } from "@/core/api/apiClient";
import { getImageUrl } from "@/config/env";
import { rootStore } from "@/mobx/store";
import { useNavigate } from "react-router-dom";

// 로그인 응답 타입
interface LoginResponse {
  accessToken: string;
  refreshToken: string;
}

// 로그인 뮤테이션
export const useLogin = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (loginData: {
      loginType: string;
      email?: string;
      password?: string;
    }) => {
      console.log("useLogin: API request started");
      const response = await apiClient.post("/auth/login", loginData);
      console.log("useLogin: API request completed");
      return response.data;
    },
    onSuccess: async (response) => {
      try {
        // 토큰 저장만 담당 (네비게이션은 로그인 페이지에서 처리)
        if (response.accessToken) {
          rootStore.setToken(response.accessToken);

          // admin을 객체 형태로 저장 (기존 형식과 호환)
          const adminData = {
            accessToken: response.accessToken,
            // 기타 필요한 사용자 정보가 있다면 추가
          };
          localStorage.setItem("admin", JSON.stringify(adminData));

          // refresh token 저장
          if (response.refreshToken) {
            localStorage.setItem("refresh_token", response.refreshToken);
          }
        }
      } catch (error) {
        console.error("로그인 후 토큰 저장 실패:", error);
      }
    },
    onError: (error) => {
      console.error("로그인 실패:", error);
    },
  });
};

// 사용자 정보 조회
export const useUser = () => {
  return useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      const response = await api.get("admins/me");
      // MobX store에 사용자 정보 저장
      rootStore.setProfile(response);
      return response;
    },
    enabled: !!rootStore.isSignedIn, // 로그인 상태에서만 호출
    staleTime: 30 * 1000, // 30초
  });
};

// 설정 정보 조회
export const useSettings = () => {
  return useQuery({
    queryKey: ["settings"],
    queryFn: () => api.get("settings"),
    staleTime: 1000 * 60 * 30, // 30분
  });
};

// 이미지 URL 생성 헬퍼 (기존 loadImage 함수 대체)
export const useImageUrl = () => {
  return (path: string) => getImageUrl(path);
};

// 클래스 목록 조회
export const useClassList = () => {
  return useQuery({
    queryKey: ["classList"],
    queryFn: async () => {
      const response = await api.get("class");
      return response.result_data || [];
    },
    enabled: false, // 500 에러 방지를 위해 비활성화
  });
};
